import {
  DOCUMENT_CANCEL,
  DOCUMENT_SIGN,
  GET_BANK_STATEMENTS_LETTER,
  GET_DOCUMENT_BY_ID,
  GET_GLOBAL_ACCOUNT_STATEMENT_LETTER,
} from '@/constants/api';
import { GENERATE_MISSING_DOCUMENTS } from '@/constants/documents';
import { OrderType } from '@/constants/orders';
import { Documents } from '@/types/company';
import {
  BankAccountStatement,
  BankAccountStatementsLetter,
} from '@/types/documents';
import { get, save } from '@/utils/request';
import { REQUEST_METHOD } from '@treyd-io/core/constants/request';

export const cancelDocumentSigning = ({ documentId }: { documentId: number }) =>
  save({
    url: DOCUMENT_CANCEL(documentId),
    method: REQUEST_METHOD.POST,
  });

export const signDocument = ({
  documentId,
  data,
}: Documents.SignDocumentPayload) =>
  save({
    url: DOCUMENT_SIGN(documentId),
    method: REQUEST_METHOD.POST,
    data,
  });

export const getDocumentById = ({
  documentableType,
  documentableId,
  documentId,
}: {
  documentableType: OrderType | 'companies';
  documentableId: number;
  documentId: number;
}) => {
  return get<Documents.DocumentType>({
    url: GET_DOCUMENT_BY_ID({
      documentableType,
      documentableId,
      documentId,
    }),
  });
};

export const getBankAccountStatementsLetter = ({
  accountId,
}: { accountId: string }) =>
  get<BankAccountStatementsLetter>({
    url: GET_BANK_STATEMENTS_LETTER(accountId),
    options: {
      params: {
        generate_missing: GENERATE_MISSING_DOCUMENTS,
      },
    },
  });

export const getGlobalAccountStatementLetter = ({
  globalAccountId,
}: { globalAccountId: string }) =>
  get<BankAccountStatement>({
    url: GET_GLOBAL_ACCOUNT_STATEMENT_LETTER(globalAccountId),
  });
